export default "__VITE_ASSET__a2l0Ga89__"